var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-goods__list mb-2"},[_c('item-list',{attrs:{"tag":"ul","item-list":_vm.itemList},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('li',{key:item.id,staticClass:"p-goods-wrapper"},[_c('item',{attrs:{"item":item,"fku-decorator":_vm.fkuDecorator},nativeOn:{"click":function($event){return _vm.onClickItem(item)}}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }